import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

import { Checkbox } from '@zocdoc-frontend-common/components-checkbox';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { Link } from '@zocdoc-frontend-common/components-link';

const labelMessage =
    'I certify that the insurance or payment selected is the one that I will be using when I see this medical professional, and that I have read and agree to the Zocdoc ';

export default class extends React.Component {
    static propTypes = {
        shouldShowCheckbox: PropTypes.bool,
        isChecked: PropTypes.bool,
        invalidMessage: PropTypes.any,
        clickUsingInsuranceWarning: PropTypes.func,
    };

    static defaultProps = {
        shouldShowCheckbox: false,
        clickUsingInsuranceWarning: () => {},
    };

    render() {
        const {
            shouldShowCheckbox,
            isChecked,
            invalidMessage,
            clickUsingInsuranceWarning,
        } = this.props;

        if (shouldShowCheckbox) {
            return (
                <UsingInsuranceCheckbox>
                    <Checkbox
                        checked={isChecked}
                        data-test="using-insurance-warning"
                        invalidMessage={invalidMessage}
                        onChecked={clickUsingInsuranceWarning}
                    >
                        {labelMessage}
                        <Link
                            href="https://www.zocdoc.com/about/terms"
                            target="_blank"
                        >
                            terms of use
                        </Link>
                        .
                    </Checkbox>
                </UsingInsuranceCheckbox>
            );
        } else {
            return null;
        }
    }
}

const UsingInsuranceCheckbox = styled(FormRow)`
    font: 13px/20px ${FontFamily.SharpSansMedium};
`;
